import { observer } from "mobx-react";
import * as React from "react";
import { Button, Classes, Dialog, FormGroup, InputGroup, NumericInput, Tab, Tabs } from "@blueprintjs/core";
import { DaeAvulsoStore } from "../../stores/dae-avulso/DaeAvulsoStore";
import TarefasDaeAvulso from "../dae-avulso/TarefasDaeAvulso";
import { MDBCol, MDBRow } from "mdbreact";
import { IReceita, IResultadoSummary, newIReceita } from "../../model";
import moment from "moment";
import { observable } from "mobx";
import { MonthPicker } from "../utils/MonthPicker";
import { toast } from "react-toastify";
import ApuracaoSaida from "../apuracao-saida/ApuracaoSaida";
import ApuracaoEntrada from "../apuracao-entrada/ApuracaoEntrada";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import IntlCurrencyInput from "react-intl-currency-input";
import RelatorioApuracaoSaida from "../apuracao-saida/RelatorioApuracaoSaida";
import Dei from "../dei/DeiPage";

const numeral = require("numeral");
const InputMask = require("react-input-mask");

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    }
  }
};

@observer
export default class ApuracoesPage extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props) {
    super(props);
  }

  /**
 * Altera a aba selecionada com base no ID fornecido.
 * 
 * A função define o ID da aba selecionada no estado de `SpedApuracaoStore.obs.selectedTab`, permitindo a navegação entre diferentes abas ou seções.
 * 
 * @param {string|number} tabId O ID da aba que deve ser selecionada.
 * 
 * @returns {void} Não retorna valor. A função apenas atualiza o estado com o ID da aba selecionada.
 */
  async handldeChargeTab(tabId) {

    if (String(tabId) === "relatorio") {

      SpedApuracaoStore.obs.page_tasks_relatorio = 1
      SpedApuracaoStore.obs.length_tasks_relatorio = 0

      await SpedApuracaoStore.handleTasksPaged(1);
      
    }

    SpedApuracaoStore.obs.selectedTab = String(tabId);

  }

  /**
 * Atualiza a data de cálculo no estado de `DaeAvulsoStore.obs.date_calculo`.
 * 
 * A função é chamada quando a data de cálculo é alterada pelo usuário. A nova data é atribuída ao estado de `DaeAvulsoStore.obs.date_calculo`.
 * 
 * @param {Date} val A nova data de cálculo selecionada.
 * 
 * @returns {void} Não retorna valor. A função apenas atualiza o estado da data de cálculo.
 */
  handleDateChange(val) {

    DaeAvulsoStore.obs.date_calculo = val

  }

  /**
 * Atualiza a data de vencimento no estado de `DaeAvulsoStore.obs.date_vencimento`.
 * 
 * A função é chamada quando a data de vencimento é alterada pelo usuário. A nova data é atribuída ao estado de `DaeAvulsoStore.obs.date_vencimento`.
 * 
 * @param {Date} val A nova data de vencimento selecionada.
 * 
 * @returns {void} Não retorna valor. A função apenas atualiza o estado da data de vencimento.
 */
  handleVencimentoChange(val) {

    DaeAvulsoStore.obs.date_vencimento = val

  }

  /**
 * Fecha o modal de DAE Avulso e limpa os dados relacionados.
 * 
 * A função é chamada quando o usuário deseja fechar o modal de DAE Avulso. Ela redefine as datas de vencimento e cálculo para `null` e cria uma nova receita vazia.
 * 
 * @returns {void} Não retorna valor. A função apenas redefine os dados e fecha o modal.
 */
  handleOnClose() {

    DaeAvulsoStore.obs.open_dae_avulso = false

    DaeAvulsoStore.obs.date_vencimento = null
    DaeAvulsoStore.obs.date_calculo = null
    DaeAvulsoStore.obs.receita = newIReceita()

  }

  /**
 * Valida e solicita a criação de um DAE (Documento de Arrecadação de Receitas).
 * 
 * A função realiza uma série de validações para garantir que os campos necessários (data de cálculo, data de vencimento e documento de origem) estejam preenchidos corretamente.
 * Se as validações forem bem-sucedidas, ela solicita a criação do DAE através da função `handleSolicitaDAE` de `DaeAvulsoStore`.
 * 
 * As validações incluem:
 * - A data de cálculo não pode ser anterior à data atual.
 * - A data de vencimento e o documento de origem devem estar preenchidos.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve após a solicitação do DAE ser processada.
 */
  async handleSolicitaDAE() {

    if (!DaeAvulsoStore.obs.receita.codigo_receita) {
      toast.warn("Campo Código da Receita é obrigatória", {});
      return
    }

    if (!DaeAvulsoStore.obs.date_calculo || moment(DaeAvulsoStore.obs.date_calculo).format("DD/MM/YYYY") == "Data inválida") {
      toast.warn("Campo Data cálculo é obrigatória", {});
      return
    }

    if (!DaeAvulsoStore.obs.receita.data_referencia || DaeAvulsoStore.obs.receita.data_referencia.includes("_")) {
      toast.warn("Campo Data referência é obrigatória", {});
      return
    }

    if (new Date(DaeAvulsoStore.obs.date_calculo).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
      toast.warn("Data do cálculo não pode ser menor que a data atual", {});
      return
    }

    if (!DaeAvulsoStore.obs.date_vencimento || moment(DaeAvulsoStore.obs.date_vencimento).format("DD/MM/YYYY") == "Data inválida") {
      toast.warn("Campo Data vencimento é obrigatório", {});
      return
    }

    if (!DaeAvulsoStore.obs.receita.documento_origem) {
      toast.warn("Campo Documento Origem é obrigatório", {});
      return
    }

    if (!DaeAvulsoStore.obs.receita.informacao_adicional) {
      toast.warn("Campo Informações adicionais é obrigatório", {});
      return
    }

    DaeAvulsoStore.obs.receita.data_calculo = moment(DaeAvulsoStore.obs.date_calculo).format("DD/MM/YYYY")
    DaeAvulsoStore.obs.receita.data_vencimento = moment(DaeAvulsoStore.obs.date_vencimento).format("DD/MM/YYYY")

    DaeAvulsoStore.obs.open_dae_avulso = false

    await DaeAvulsoStore.handleSolicitaDAE(DaeAvulsoStore.obs.receita)

  }


  handleChangeReceita = (valueAsNumber: number, valueAsString: string) => {

    DaeAvulsoStore.obs.receita.codigo_receita = valueAsString

  };

  handleChangePagar = (event, value, maskedValue) => {

    DaeAvulsoStore.obs.receita.valor_pagar = value

  }

  render() {

    return (<>

      <Tabs
        id="tabs"
        className="tabsCalculos tabsApuracao"
        selectedTabId={SpedApuracaoStore.obs.selectedTab}
        onChange={(tabId) => this.handldeChargeTab(tabId)}
        data-tut="resumo"
      >
        <Tab
          id="apuracao_entrada"
          title="Apuração Entrada"
          panel={<ApuracaoEntrada />}
        />

        <Tab
          id="apuracao_saida"
          title="Apuração Saída"
          panel={<ApuracaoSaida />}
        />
        
        <Tab
          id="tarefas"
          title="Tarefas Dae Avulso"
          panel={<TarefasDaeAvulso />}
        />

        <Tab
          id="relatorio"
          title="Resultados Exportar Excel"
          panel={<RelatorioApuracaoSaida />}
        />

      </Tabs>

      <Dialog
        isOpen={DaeAvulsoStore.obs.open_dae_avulso}
        onClose={() => DaeAvulsoStore.obs.open_dae_avulso = false}
        title="Solicitar Dae Avulso"
      >
        <div className={Classes.DIALOG_BODY}>
          <MDBRow>

            <MDBCol>
              <FormGroup label="Código da Receita">
                <NumericInput className="input-numeric" value={DaeAvulsoStore.obs.receita.codigo_receita} onValueChange={this.handleChangeReceita} buttonPosition="none" placeholder="Exemplo: 1145" />
              </FormGroup>
            </MDBCol>

            <MDBCol>
              <FormGroup label="Valor a pagar">
                <IntlCurrencyInput
                  className="form-control"
                  value={DaeAvulsoStore.obs.receita.valor_pagar}
                  precision={2}
                  onChange={this.handleChangePagar}
                  currency="BRL"
                  config={currencyConfig}
                />
              </FormGroup>
            </MDBCol>

            <MDBCol>
              <FormGroup label="Data referência">
                <InputMask
                    mask="99/9999"
                    className="form-control"
                    onChange={(e) => DaeAvulsoStore.obs.receita.data_referencia = e.target.value}
                    value={DaeAvulsoStore.obs.receita.data_referencia}
                  />
              </FormGroup>
            </MDBCol>

          </MDBRow>

          <MDBRow>

            <MDBCol>
              <FormGroup label="Vencimento Original">
                <MonthPicker onChange={(e) => this.handleDateChange(e)} value={DaeAvulsoStore.obs.date_calculo} />
              </FormGroup>
            </MDBCol>

            <MDBCol>
              <FormGroup label="Pagar até">
                <MonthPicker onChange={(e) => this.handleVencimentoChange(e)} value={DaeAvulsoStore.obs.date_vencimento} />
              </FormGroup>
            </MDBCol>

            <MDBCol>
              <FormGroup label="Documento origem">
                <InputGroup
                  type="number"
                  value={DaeAvulsoStore.obs.receita.documento_origem}
                  onChange={(e: any) => DaeAvulsoStore.obs.receita.documento_origem = e.target.value}
                />
              </FormGroup>
            </MDBCol>
          </MDBRow>

          <FormGroup label="Informações adicionais">
            <InputGroup
              value={DaeAvulsoStore.obs.receita.informacao_adicional}
              onChange={(e) => DaeAvulsoStore.obs.receita.informacao_adicional = e.target.value}
            />
          </FormGroup>

        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.handleOnClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleSolicitaDAE()} />
          </div>
        </div>

      </Dialog>

    </>
    );
  }
}
